export const LOCATIONS = {
  HOME_PAGE: '/',
  DASHBOARD: '/dashboard',
  MANAGER_BOOKING: '/manager-booking',
  MANAGER_BOOKING_DETAIL: '/manager-booking/:id',

  NOT_FOUND: '/404-NOT-FOUND',

  LOGIN: '/login',
  LOGIN_INTRANET: '/login-intranet',

  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CREATE_PASSWORD: '/create-password',
  TERMS_OF_USE: '/terms-of-use',
  OPERATING_RULES: '/operating-rules',

  PROFILE: '/profile',
  CHANGE_PASSWORD: '/change-password',
  CONTRACT: '/locations/detail/contract',

  MEDIA: '/media',
  MEDIA_VIEW: '/media/:id',

  BOOKING: '/booking',
  FINANCE: '/finance',

  LOCATION_LIST: '/locations',
  LOCATION_ADD: '/locations/add',
  ADD_ALREADY_LOCATION: '/locations/already-location',

  // DETAIL LOCATION
  LOCATION_DETAIL: {
    DASHBOARD: '/locations/detail/dashboard',
    DEFAULT: '/locations/detail',
    NEAR_LOCATION: '/locations/detail/near-location',
    CONTACT_INFORMATION: '/locations/detail/contact-information',
    POLICY: '/locations/detail/policy',
    CONVENIENCE_SERVICE: '/locations/detail/conveniences-services',
    ROOMS_OF_PLACE: '/locations/detail/rooms',
    CREATE_ROOM: '/locations/detail/room/create',
    EDIT_ROOM: '/locations/detail/room/edit',
    CONVENIENCE_ROOM: '/locations/detail/convenience-room',
    DETAIL_PICTURE: '/locations/detail/picture',
    DETAIL_REVIEWS: '/locations/detail/reviews',
    REVIEW_DETAIL: '/locations/detail/review',
    DETAIL_CALENDAR: '/locations/detail/calendar/',
    OPEN_CLOSE_ROOM: '/locations/detail/open-close-rooms',
    UPDATE_AMOUNT_ROOM: '/locations/detail/update-amount-rooms',
    UPDATE_PRICE: '/locations/detail/update-price',
    LIST_PRICE_TYPE: '/locations/detail/list-price-type',
    ADD_PRICE_TYPE: '/locations/detail/add-price-type',
    EDIT_PRICE_TYPE: '/locations/detail/edit-price-type',
    PROMOTION: '/locations/detail/promotions',
    CREATE_PROMOTION: '/locations/detail/promotions/create',
    CREATE_BASIC_PROMOTION:
      '/locations/detail/promotions/create/basic-promotion',
    CREATE_LONG_TERM_PROMOTION:
      '/locations/detail/promotions/create/long-term-promotion',
    CREATE_LAST_MINUTE_PROMOTION:
      '/locations/detail/promotions/create/last-minute-promotion',
    CREATE_EARLY_PROMOTION:
      '/locations/detail/promotions/create/early-promotion',
    CREATE_TOURIST_PROMOTION:
      '/locations/detail/promotions/create/tourist-promotion',
    CREATE_ENTERPRISE_PROMOTION:
      '/locations/detail/promotions/create/ambassador-promotion',
    CREATE_AGENCY_PROMOTION:
      '/locations/detail/promotions/create/agency-promotion',
    CREATE_RANK_PROMOTION:
      '/locations/detail/promotions/create/rank-promotion',
    CREATE_MARKETING_PROMOTION:
      '/locations/detail/promotions/create/marketing-promotion',
    CHILD_EXTRA_BED_POLICY: '/locations/detail/policy/child-extra-bed-policy',
    FINANCE: '/locations/detail/finance',
    FINANCE_DETAIL: '/locations/detail/finance/:id',
    ANALYSIS_OVERVIEW: '/locations/detail/analytics/overview',
    MANAGER_BOOKING: '/locations/detail/manager-booking',
    CANCELLATION_POLICY: '/locations/detail/cancellation-policy',
    MESSAGES_WITH_CUSTOMERS: '/locations/detail/messages-with-customers',
    VAT_SERVICE: '/locations/detail/vat-service',
  },

  MANAGER_MARKET: '/manager-market',
  LIST_OF_AREAS: '/list-of-areas',
  FAVORITE_PLACE: '/favorite-place',

  CUSTOMERS: '/customers',

  CUSTOMER_DETAILS: '/customers/:id',

  MANAGER_REVIEWS: '/manager-reviews',
  MANAGER_REVIEWS_DETAIL: '/manager-reviews/detail',

  MANAGER_PROMOTION: '/manager-promotion',

  MANAGER_OPERATION: '/manager-operation',

  MANAGER_COIN: '/manager-coin',

  // MANAGER_USER_ACCOUNT: '/manager-user-account',
  MANAGER_INTERNAL_ACCOUNT: '/manager-internal-account',
  MANAGER_ACCOMMODATION_ACCOUNT: '/manager-accommodation-account',
  MANAGER_CUSTOMER_ACCOUNT: '/manager-customer-account',

  MANAGER_REVENUE: '/manager-revenue',
  MANAGER_PAYMENT: '/manager-payment',
  MANAGER_PAYMENT_DETAIL: '/manager-payment/:id',
  MANAGER_TAX: '/manager-tax',

  MANAGER_COMPLAINT: '/manager-complaints',
  MANAGER_COMPLAINT_DETAIL: '/manager-complaints/:id',
  MANAGER_REFLECT: '/manager-reflect',
  MANAGER_REFLECT_DETAIL: '/manager-reflect/:id',
  MANAGER_TCXH_FEEDBACK: '/manager-reflect',
  MANAGER_TCXH_FEEDBACK_DETAIL: '/manager-reflect/:id',
};

export const SITE_NAME = 'Bookese';
export const COMPANY = 'Wiicamp';

// Storage key
export const storageKey = {
  AUTHENTICATE_TOKEN: 'AUTHENTICATE_TOKEN',
  AUTHENTICATE_REFRESH_TOKEN: 'AUTHENTICATE_REFRESH_TOKEN',
  LOGIN_TYPE: 'LOGIN_TYPE',
  EXTRANET_SELLER_WARNING_ACCEPTED: 'EXTRANET_SELLER_WARNING_ACCEPTED',
};

export const LOGIN_TYPE = {
  INTRANET: 'INTRANET',
  EXTRANET: 'EXTRANET',
};

export const DEBOUNCE_SEARCH_DELAY = 300;

export const LIMIT_FILE_SIZE = {
  NORMAL: 5 * 1024 * 1024,
  LARGE: 15 * 1024 * 1024,
  BIG: 30 * 1024 * 1024,
};

export const themeColor = {
  DANGER: 'danger',
  INFO: 'info',
  LIGHT: 'light',
  LINK: 'link',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
};

// sẽ xóa sau khi có data mới
export const employeeType = {
  FULLTIME: 'FULLTIME',
  PARTTIME: 'PARTTIME',
  INTERN: 'INTERN',
};

export const employeeTypeSelectList = [
  {
    value: employeeType.FULLTIME,
    color: themeColor.SUCCESS,
  },
  {
    value: employeeType.PARTTIME,
    color: themeColor.INFO,
  },
  {
    value: employeeType.INTERN,
    color: 'warning',
  },
];

export const userGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
};

export const UserGenderLabel = {
  [userGender.MALE]: 'Nam',
  [userGender.FEMALE]: 'Nữ',
  [userGender.OTHER]: 'Khác',
};

export const userGenderSelectList = [
  { value: userGender.MALE, label: UserGenderLabel[userGender.MALE] },
  { value: userGender.FEMALE, label: UserGenderLabel[userGender.FEMALE] },
  { value: userGender.OTHER, label: UserGenderLabel[userGender.OTHER] },
];

export const mediaTypeSelectList = [
  {
    value: 0,
  },
  {
    value: 1,
  },
  {
    value: 2,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
];

export const mediaFolder = {
  AVATAR: 'AVATAR',
  ORGANIZATION: 'ORGANIZATION',
  INVOICE: 'INVOICE',
  SKILL: 'SKILL',
  PROJECT: 'PROJECT',
};

export const mediaFolderSelectList = [
  {
    value: mediaFolder.AVATAR,
  },
  {
    value: mediaFolder.ORGANIZATION,
  },
  {
    value: mediaFolder.INVOICE,
  },
  {
    value: mediaFolder.SKILL,
  },
  {
    value: mediaFolder.PROJECT,
  },
];

export const mediaMimeType = {
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  PDF: 'application/pdf',
  EXCEL: 'application/vnd.ms-excel',
  SHEET: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  WORD: 'application/msword',
  DOCUMENT:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const mediaMimeTypeSelectList = [
  {
    value: mediaMimeType.JPEG,
  },
  {
    value: mediaMimeType.PNG,
  },
  {
    value: mediaMimeType.PDF,
  },
  {
    value: mediaMimeType.EXCEL,
  },
  {
    value: mediaMimeType.SHEET,
  },
  {
    value: mediaMimeType.WORD,
  },
  {
    value: mediaMimeType.DOCUMENT,
  },
];

export const imageType = {
  PDF: 'pdf',
};

export const searchType = {
  STATUS: 'status',
  REQUEST: 'request',
  CASHFLOW_TYPE: 'cashflow-type',
  PERSONAL_CLIENT: 'personal-client',
  BUSINESS_CLIENT: 'business-client',
  TRANSACTION_CLASSIFICATION: 'transaction-classification',
  STATUS_PROJECT: 'status-project',
  MEDIA_FOLDER: 'media-folder',
  MEDIA_TYPE: 'media-type',
  STATUS_SLIDE: 'status-slide',
};

export const typeMediaUpload = {
  TRANSACTION: 'TRANSACTION',
  DEFAULT: 'DEFAULT',
};

export const allowPermission = {
  // PUBLISH PERMISSIONS
  HOME: 'HOME',
  PROFILE: 'PROFILE',
  MY_REQUEST: 'MY_REQUEST',
  LEAVE_REQUEST: 'LEAVE_REQUEST',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',

  // MEDIA
  VIEW_ALL_MEDIA: 'VIEW_ALL_MEDIA',
  VIEW_LIST_MEDIA: 'VIEW_LIST_MEDIA',
  VIEW_DETAIL_MEDIA: 'VIEW_DETAIL_MEDIA',
  EDIT_MEDIA: 'EDIT_MEDIA',
  DELETE_MEDIA: 'DELETE_MEDIA',
};

export const statusSlide = {
  PUBLIC: 'PUBLIC',
  PENDING: 'PENDING',
};

export const validationCheckErrorType = {
  ERR_ONLY: 'ERR_ONLY',
  TOUCHED_ONLY: 'TOUCHED_ONLY',
};

export const UPLOAD_FILE_TYPE = {
  PICTURE_ONLY: 'PICTURE_ONLY',
  VIDEO_ONLY: 'VIDEO_ONLY',
};

export const ORDER_STATUS = {
  ALL: '',
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'CANCELLED',
  DELIVERING: 'DELIVERING',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  PAID: 'PAID',
  PENDING: 'PENDING',
  PREPARING: 'PREPARING',
  RECEIVED: 'RECEIVED',
  REJECTED: 'REJECTED',
  WAITING_PAYMENT: 'WAITING_PAYMENT',
};

export const VOUCHER_DISCOUNT_TYPES = {
  PRICE: 'PRICE',
  PERCENT: 'PERCENT',
};

export const VOUCHER_STATUSES = {
  ALL: {
    text: 'Tất cả',
    label: 'ALL',
  },
  NEW: {
    code: 0,
  },
  UPCOMING: {
    text: 'Sắp diễn ra',
    value: 'UPCOMING',
    label: 'UPCOMING',
    code: 1,
    class: 'badge-danger-custom',
  },
  ONGOING: {
    text: 'Đang diễn ra',
    value: 'ONGOING',
    label: 'ONGOING',
    code: 2,
    class: 'badge-success-custom',
  },
  ENDED: {
    text: 'Đã kết thúc',
    value: 'ENDED',
    label: 'ENDED',
    code: 3,
    class: 'badge-info-custom',
  },
};

export const VOUCHER_MAXIMUM_DISCOUNT_TYPE = {
  LIMITED: 'LIMITED',
  UNLIMITED: 'UNLIMITED',
};

export const MODAL_ADD_LOCATION_TAB = {
  NEW: 'NEW',
  ALREADY: 'ALREADY',
};

export const ARRAY_OF_PHONE_LINES = [1, 2, 3, 4, 5, 6];

export const ROOM_FACILITIES_TYPE = {
  ALL_ROOMS: 'ALL_ROOMS',
  SOME_ROOMS: 'SOME_ROOMS',
  NO_ROOM: 'NO_ROOM',
};

export const priceType = {
  STANDARD_PRICE: 'STANDARD_PRICE',
  NON_REFUNDABLE_PRICE: 'NON_REFUNDABLE_PRICE',
  CUSTOM_PRICE: 'CUSTOM_PRICE',
};

export const BOOKING_TAB = {
  ALL: '',
  PENDING: 'PENDING',
  BOOKED: 'BOOKED',
  APPROVED: 'APPROVED',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  MODIFIED: 'MODIFIED',
};

export const GIFT_LIST_TAB = {
  ALL: '',
  PUBLIC: 'PUBLIC',
  HIDDEN: 'HIDDEN',
  EXPIRED: 'EXPIRED',
};

export const VOUCHER_CAMPAIGN_TAB = {
  ALL: '',
  UPCOMING: 'UPCOMING',
  ONGOING: 'ONGOING',
  ENDED: 'ENDED',
};

export const BOOKING_STATUS = {
  SUCCESS: { label: 'Đã hoàn thành', key: 'SUCCESS' },
  PAYMENT_FAILED: { label: 'Thanh toán thất bại', key: 'PAYMENT_FAILED' },
  PENDING: { label: 'Chờ thanh toán', key: 'PENDING' },
  APPROVED: { label: 'Đã xác nhận', key: 'APPROVED' },
  MODIFIED: { label: 'Đã điều chỉnh', key: 'MODIFIED' },
  // Transient BE status between payment and the Hotellink push; a booking stuck here past its
  // normal window is exactly what WP-ADM-OTA-SYNC surfaces to admin.
  PROCESSING: { label: 'Đang xử lý', key: 'PROCESSING' },
  CANCELLED_BY_USER: { label: 'Đã huỷ', key: 'CANCELLED_BY_USER' },
  CANCELLED_BY_PLACE: { label: 'Đã huỷ', key: 'CANCELLED_BY_PLACE' },
  PAID: { label: 'Đã đặt phòng', key: 'PAID' },
  WAITING_FOR_REFUND: { label: 'Đã hủy và đợi hoàn tiền', key: 'WAITING_FOR_REFUND' },
  REFUNDED: { label: 'Đã hủy và đã hoàn tiền', key: 'REFUNDED' },
};

export const USER_RANK = {
  MEMBER: {
    label: 'Member',
    value: 'MEMBER',
    color: 'Member',
  },
  TRUST: {
    label: 'Trust',
    value: 'TRUST',
    color: 'Trust',
  },
  AGENT: {
    label: 'Agent',
    value: 'AGENT',
    color: 'Agent',
  },
};

export const TRAVEL_TYPE = {
  BUSINESS_TRIP: {
    label: 'Công tác',
    value: 'BUSINESS_TRIP',
  },
  TRAVEL: {
    label: 'Du lịch',
    value: 'TRAVEL',
  },
  OTHER: {
    label: 'Khác',
    value: 'OTHER',
  },
};

export const PLACE_TYPE = {
  HOTEL: {
    label: 'Khách sạn',
    value: 'HOTEL',
  },
  RESORT: {
    label: 'Resort',
    value: 'RESORT',
  },
  APARTMENT: {
    label: 'Căn hộ',
    value: 'APARTMENT',
  },
  VILLA: {
    label: 'Biệt thự',
    value: 'VILLA',
  },
};

export const CANCEL_PENALTY_TYPE = {
  FIRST_NIGHT: {
    label: 'Đêm đầu tiên',
    value: 'FIRST_NIGHT',
  },
  '50_PERCENT': {
    label: '50%',
    value: '50_PERCENT',
  },
  '100_PERCENT': {
    label: '100%',
    value: '100_PERCENT',
  },
};

export const OPTION_CANCEL_PENALTY = {
  FIRST_NIGHT: { value: 'FIRST_NIGHT', label: 'Giá của đêm đầu tiên' },
  '50_PERCENT': { value: '50_PERCENT', label: '50% tổng tiền phòng' },
  '100_PERCENT': { value: '100_PERCENT', label: '100% tổng tiền phòng' },
};

export const OPTION_ABSENT_PENALTY = {
  EQUAL_CANCEL_PENALTY: {
    value: 'EQUAL_CANCEL_PENALTY',
    label: 'Bằng phí huỷ đặt phòng',
  },
  '100_PERCENT': { value: '100_PERCENT', label: '100% tổng tiền phòng' },
};

export const ROOM_STATUS = {
  CLOSE: 'CLOSE',
  AVAILABLE: 'AVAILABLE',
};

export const ROOM_TYPE = {
  // STANDARD
  STANDARD_ROOM: {
    label: 'Phòng Đơn',
    value: 'STANDARD_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_SINGLE_ROOM: {
    label: 'Phòng Standard 1 Giường Đơn',
    value: 'STANDARD_SINGLE_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_DOUBLE_ROOM: {
    label: 'Phòng Standard 1 Giường Đôi',
    value: 'STANDARD_DOUBLE_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_TWIN_ROOM: {
    label: 'Phòng Standard 2 Giường Đơn',
    group: 'STANDARD_ROOM',
    value: 'STANDARD_TWIN_ROOM',
  },
  STANDARD_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Standard 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'STANDARD_DOUBLE_OR_TWIN_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_QUEEN_ROOM: {
    label: 'Phòng Standard 1 Giường Queen',
    value: 'STANDARD_QUEEN_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_KING_ROOM: {
    label: 'Phòng Standard 1 Giường King',
    value: 'STANDARD_KING_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_TRIPLE_ROOM: {
    label: 'Phòng Standard 3 Khách',
    value: 'STANDARD_TRIPLE_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_QUADRUPLE_ROOM: {
    label: 'Phòng Standard 4 Khách',
    value: 'STANDARD_QUADRUPLE_ROOM',
    group: 'STANDARD_ROOM',
  },
  STANDARD_FAMILY_ROOM: {
    label: 'Phòng Standard Gia Đình',
    value: 'STANDARD_FAMILY_ROOM',
    group: 'STANDARD_ROOM',
  },
  // SUPERIOR
  SUPERIOR_SINGLE_ROOM: {
    label: 'Phòng Superior 1 Giường Đơn',
    value: 'SUPERIOR_SINGLE_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_DOUBLE_ROOM: {
    label: 'Phòng Superior 1 Giường Đôi',
    value: 'SUPERIOR_DOUBLE_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_TWIN_ROOM: {
    label: 'Phòng Superior 2 Giường Đơn',
    value: 'SUPERIOR_TWIN_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Superior 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'SUPERIOR_DOUBLE_OR_TWIN_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_QUEEN_ROOM: {
    label: 'Phòng Superior 1 Giường Queen',
    value: 'SUPERIOR_QUEEN_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_KING_ROOM: {
    label: 'Phòng Superior 1 Giường King',
    value: 'SUPERIOR_KING_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_TRIPLE_ROOM: {
    label: 'Phòng Superior 3 Khách',
    value: 'SUPERIOR_TRIPLE_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_QUADRUPLE_ROOM: {
    label: 'Phòng Superior 4 Khách',
    value: 'SUPERIOR_QUADRUPLE_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  SUPERIOR_FAMILY_ROOM: {
    label: 'Phòng Superior Gia Đình',
    value: 'SUPERIOR_FAMILY_ROOM',
    group: 'SUPERIOR_ROOM',
  },
  // DELUXE
  DELUXE_SINGLE_ROOM: {
    label: 'Phòng Deluxe 1 Giường Đơn',
    value: 'DELUXE_SINGLE_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_DOUBLE_ROOM: {
    label: 'Phòng Deluxe 1 Giường Đôi',
    value: 'DELUXE_DOUBLE_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_TWIN_ROOM: {
    label: 'Phòng Deluxe 2 Giường Đơn',
    value: 'DELUXE_TWIN_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Deluxe 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'DELUXE_DOUBLE_OR_TWIN_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_QUEEN_ROOM: {
    label: 'Phòng Deluxe 1 Giường Queen',
    value: 'DELUXE_QUEEN_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_KING_ROOM: {
    label: 'Phòng Deluxe 1 Giường King',
    value: 'DELUXE_KING_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_TRIPLE_ROOM: {
    label: 'Phòng Deluxe 3 Khách',
    value: 'DELUXE_TRIPLE_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_QUADRUPLE_ROOM: {
    label: 'Phòng Deluxe 4 Khách',
    value: 'DELUXE_QUADRUPLE_ROOM',
    group: 'DELUXE_ROOM',
  },
  DELUXE_FAMILY_ROOM: {
    label: 'Phòng Deluxe Gia Đình',
    value: 'DELUXE_FAMILY_ROOM',
    group: 'DELUXE_ROOM',
  },
  // PREMIER
  PREMIER_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Premier 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'PREMIER_SINGLE_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_DOUBLE_ROOM: {
    label: 'Phòng Premier 1 Giường Đôi',
    value: 'PREMIER_DOUBLE_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_TWIN_ROOM: {
    label: 'Phòng Premier 2 Giường Đơn',
    value: 'PREMIER_TWIN_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_QUEEN_ROOM: {
    label: 'Phòng Premier 1 Giường Queen',
    value: 'PREMIER_QUEEN_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_KING_ROOM: {
    label: 'Phòng Premier 1 Giường King',
    value: 'PREMIER_KING_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_TRIPLE_ROOM: {
    label: 'Phòng Premier 3 Khách',
    value: 'PREMIER_TRIPLE_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_QUADRUPLE_ROOM: {
    label: 'Phòng Premier 4 Khách',
    value: 'PREMIER_QUADRUPLE_ROOM',
    group: 'PREMIER_ROOM',
  },
  PREMIER_FAMILY_ROOM: {
    label: 'Phòng Premier Gia Đình',
    value: 'PREMIER_FAMILY_ROOM',
    group: 'PREMIER_ROOM',
  },
  // PREMIUM
  PREMIUM_DOUBLE_ROOM: {
    label: 'Phòng Premium 1 Giường Đôi',
    value: 'PREMIUM_DOUBLE_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_TWIN_ROOM: {
    label: 'Phòng Premium 2 Giường Đơn',
    value: 'PREMIUM_TWIN_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Premium 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'PREMIUM_DOUBLE_OR_TWIN_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_QUEEN_ROOM: {
    label: 'Phòng Premium 1 Giường Queen',
    value: 'PREMIUM_QUEEN_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_KING_ROOM: {
    label: 'Phòng Premium 1 Giường King',
    value: 'PREMIUM_KING_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_TRIPLE_ROOM: {
    label: 'Phòng Premium 3 Khách',
    value: 'PREMIUM_TRIPLE_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_QUADRUPLE_ROOM: {
    label: 'Phòng Premium 4 Khách',
    value: 'PREMIUM_QUADRUPLE_ROOM',
    group: 'PREMIUM_ROOM',
  },
  PREMIUM_FAMILY_ROOM: {
    label: 'Phòng Premium Gia Đình',
    value: 'PREMIUM_FAMILY_ROOM',
    group: 'PREMIUM_ROOM',
  },
  // PREMIER_DELUXE
  PREMIER_DELUXE_DOUBLE_ROOM: {
    label: 'Phòng Premier Deluxe 1 Giường Đôi',
    value: 'PREMIER_DELUXE_DOUBLE_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_TWIN_ROOM: {
    label: 'Phòng Premier Deluxe 2 Giường Đơn',
    value: 'PREMIER_DELUXE_TWIN_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Premier Deluxe 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'PREMIER_DELUXE_DOUBLE_OR_TWIN_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_QUEEN_ROOM: {
    label: 'Phòng Premier Deluxe 1 Giường Queen',
    value: 'PREMIER_DELUXE_QUEEN_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_KING_ROOM: {
    label: 'Phòng Premier Deluxe 1 Giường King',
    value: 'PREMIER_DELUXE_KING_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_TRIPLE_ROOM: {
    label: 'Phòng Premier Deluxe 3 Khách',
    value: 'PREMIER_DELUXE_TRIPLE_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_QUADRUPLE_ROOM: {
    label: 'Phòng Premier Deluxe 4 Khách',
    value: 'PREMIER_DELUXE_QUADRUPLE_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  PREMIER_DELUXE_FAMILY_ROOM: {
    label: 'Phòng Premier Deluxe Gia Đình',
    value: 'PREMIER_DELUXE_FAMILY_ROOM',
    group: 'PREMIER_DELUXE_ROOM',
  },
  // PREMIUM_DELUXE
  PREMIUM_DELUXE_DOUBLE_ROOM: {
    label: 'Phòng Premium Deluxe 1 Giường Đôi',
    value: 'PREMIUM_DELUXE_DOUBLE_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_TWIN_ROOM: {
    label: 'Phòng Premium Deluxe 2 Giường Đơn',
    value: 'PREMIUM_DELUXE_TWIN_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Premium Deluxe 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'PREMIUM_DELUXE_DOUBLE_OR_TWIN_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_QUEEN_ROOM: {
    label: 'Phòng Premium Deluxe 1 Giường Queen',
    value: 'PREMIUM_DELUXE_QUEEN_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_KING_ROOM: {
    label: 'Phòng Premium Deluxe 1 Giường King',
    value: 'PREMIUM_DELUXE_KING_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_TRIPLE_ROOM: {
    label: 'Phòng Premium Deluxe 3 Khách',
    value: 'PREMIUM_DELUXE_TRIPLE_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_QUADRUPLE_ROOM: {
    label: 'Phòng Premium Deluxe 4 Khách',
    value: 'PREMIUM_DELUXE_QUADRUPLE_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  PREMIUM_DELUXE_FAMILY_ROOM: {
    label: 'Phòng Premium Deluxe Gia Đình',
    value: 'PREMIUM_DELUXE_FAMILY_ROOM',
    group: 'PREMIUM_DELUXE_ROOM',
  },
  // EXECUTIVE_DOUBLE
  EXECUTIVE_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Executive 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'EXECUTIVE_DOUBLE_OR_TWIN_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_DOUBLE_ROOM: {
    label: 'Phòng Executive 1 Giường Đôi',
    value: 'EXECUTIVE_DOUBLE_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_TWIN_ROOM: {
    label: 'Phòng Executive 2 Giường Đơn',
    value: 'EXECUTIVE_TWIN_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_QUEEN_ROOM: {
    label: 'Phòng Executive 1 Giường Queen',
    value: 'EXECUTIVE_QUEEN_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_KING_ROOM: {
    label: 'Phòng Executive 1 Giường King',
    value: 'EXECUTIVE_KING_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_TRIPLE_ROOM: {
    label: 'Phòng Executive 3 Khách',
    value: 'EXECUTIVE_TRIPLE_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_QUADRUPLE_ROOM: {
    label: 'Phòng Executive 4 Khách',
    value: 'EXECUTIVE_QUADRUPLE_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  EXECUTIVE_FAMILY_ROOM: {
    label: 'Phòng Executive Gia Đình',
    value: 'EXECUTIVE_FAMILY_ROOM',
    group: 'EXECUTIVE_DOUBLE_ROOM',
  },
  // EXECUTIVE_DELUXE
  EXECUTIVE_DELUXE_DOUBLE_ROOM: {
    label: 'Phòng Executive Deluxe 1 Giường Đôi',
    value: 'EXECUTIVE_DELUXE_DOUBLE_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_TWIN_ROOM: {
    label: 'Phòng Executive Deluxe 2 Giường Đơn',
    value: 'EXECUTIVE_DELUXE_TWIN_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_DOUBLE_OR_TWIN_ROOM: {
    label: 'Phòng Executive Deluxe 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'EXECUTIVE_DELUXE_DOUBLE_OR_TWIN_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_QUEEN_ROOM: {
    label: 'Phòng Executive Deluxe 1 Giường Queen',
    value: 'EXECUTIVE_DELUXE_QUEEN_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_KING_ROOM: {
    label: 'Phòng Executive Deluxe 1 Giường King',
    value: 'EXECUTIVE_DELUXE_KING_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_TRIPLE_ROOM: {
    label: 'Phòng Executive Deluxe 3 Khách',
    value: 'EXECUTIVE_DELUXE_TRIPLE_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_QUADRUPLE_ROOM: {
    label: 'Phòng Executive Deluxe 4 Khách',
    value: 'EXECUTIVE_DELUXE_QUADRUPLE_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  EXECUTIVE_DELUXE_FAMILY_ROOM: {
    label: 'Phòng Executive Deluxe Gia Đình',
    value: 'EXECUTIVE_DELUXE_FAMILY_ROOM',
    group: 'EXECUTIVE_DELUXE_ROOM',
  },
  // BUNGALOW_STANDARD
  STANDARD_SINGLE_BUNGALOW: {
    label: 'Bungalow Standard 1 Giường Đơn',
    value: 'STANDARD_SINGLE_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_DOUBLE_OR_TWIN_BUNGALOW: {
    label: 'Bungalow Standard 1 Giường Đôi',
    value: 'STANDARD_DOUBLE_OR_TWIN_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_DOUBLE_BUNGALOW: {
    label: 'Bungalow Standard 2 Giường Đơn',
    value: 'STANDARD_DOUBLE_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_TWIN_BUNGALOW: {
    label: 'Bungalow Standard 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'STANDARD_TWIN_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_QUEEN_BUNGALOW: {
    label: 'Bungalow Standard 1 Giường Queen',
    value: 'STANDARD_QUEEN_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_KING_BUNGALOW: {
    label: 'Bungalow Standard 1 Giường King',
    value: 'STANDARD_KING_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_TRIPLE_BUNGALOW: {
    label: 'Bungalow Standard 3 Khách',
    value: 'STANDARD_TRIPLE_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_QUADRUPLE_BUNGALOW: {
    label: 'Bungalow Standard 4 Khách',
    value: 'STANDARD_QUADRUPLE_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  STANDARD_FAMILY_BUNGALOW: {
    label: 'Bungalow Standard Gia Đình',
    value: 'STANDARD_FAMILY_BUNGALOW',
    group: 'BUNGALOW_STANDARD_ROOM',
  },
  // BUNGALOW_SUPERIOR
  SUPERIOR_SINGLE_BUNGALOW: {
    label: 'Bungalow Superior 1 Giường Đơn',
    value: 'SUPERIOR_SINGLE_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_DOUBLE_OR_TWIN_BUNGALOW: {
    label: 'Bungalow Superior 1 Giường Đôi',
    value: 'SUPERIOR_DOUBLE_OR_TWIN_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_DOUBLE_BUNGALOW: {
    label: 'Bungalow Superior 2 Giường Đơn',
    value: 'SUPERIOR_DOUBLE_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_TWIN_BUNGALOW: {
    label: 'Bungalow Superior 1 Giường Đôi hoặc 2 Giường Đơn',
    value: 'SUPERIOR_TWIN_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_QUEEN_BUNGALOW: {
    label: 'Bungalow Superior 1 Giường Queen',
    value: 'SUPERIOR_QUEEN_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_KING_BUNGALOW: {
    label: 'Bungalow Superior 1 Giường King',
    value: 'SUPERIOR_KING_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_TRIPLE_BUNGALOW: {
    label: 'Bungalow Superior 3 Khách',
    value: 'SUPERIOR_TRIPLE_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_QUADRUPLE_BUNGALOW: {
    label: 'Bungalow Superior 4 Khách',
    value: 'SUPERIOR_QUADRUPLE_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  SUPERIOR_FAMILY_BUNGALOW: {
    label: 'Bungalow Superior Gia Đình',
    value: 'SUPERIOR_FAMILY_BUNGALOW',
    group: 'BUNGALOW_SUPERIOR_ROOM',
  },
  // BUNGALOW_DELUXE
  DELUXE_SINGLE_BUNGALOW: {
    label: 'Bungalow Deluxe 1 Giường Đơn',
    value: 'DELUXE_SINGLE_BUNGALOW',
    group: 'BUNGALOW_DELUXE_ROOM',
  },
  DELUXE_DOUBLE_OR_TWIN_BUNGALOW: {
    label: 'Bungalow Deluxe 1 Giường Đôi',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_DOUBLE_OR_TWIN_BUNGALOW',
  },
  DELUXE_DOUBLE_BUNGALOW: {
    label: 'Bungalow Deluxe 2 Giường Đơn',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_DOUBLE_BUNGALOW',
  },
  DELUXE_TWIN_BUNGALOW: {
    label: 'Bungalow Deluxe 1 Giường Đôi hoặc 2 Giường Đơn',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_TWIN_BUNGALOW',
  },
  DELUXE_QUEEN_BUNGALOW: {
    label: 'Bungalow Deluxe 1 Giường Queen',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_QUEEN_BUNGALOW',
  },
  DELUXE_KING_BUNGALOW: {
    label: 'Bungalow Deluxe 1 Giường King',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_KING_BUNGALOW',
  },
  DELUXE_TRIPLE_BUNGALOW: {
    label: 'Bungalow Deluxe 3 Khách',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_TRIPLE_BUNGALOW',
  },
  DELUXE_QUADRUPLE_BUNGALOW: {
    label: 'Bungalow Deluxe 4 Khách',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_QUADRUPLE_BUNGALOW',
  },
  DELUXE_FAMILY_BUNGALOW: {
    label: 'Bungalow Deluxe Gia Đình',
    group: 'BUNGALOW_DELUXE_ROOM',
    value: 'DELUXE_FAMILY_BUNGALOW',
  },
  // STUDIO
  ONE_BEDROOM_APARTMENT: {
    label: 'Căn Hộ 1 Phòng Ngủ',
    value: 'ONE_BEDROOM_APARTMENT',
    group: 'STUDIO',
  },
  TWO_BEDROOM_APARTMENT: {
    label: 'Căn Hộ 2 Phòng Ngủ',
    group: 'STUDIO',
    value: 'TWO_BEDROOM_APARTMENT',
  },
  THREE_BEDROOM_APARTMENT: {
    label: 'Căn Hộ 3 Phòng Ngủ',
    group: 'STUDIO',
    value: 'THREE_BEDROOM_APARTMENT',
  },
  FOUR_BEDROOM_APARTMENT: {
    label: 'Căn Hộ 4 Phòng Ngủ',
    group: 'STUDIO',
    value: 'FOUR_BEDROOM_APARTMENT',
  },
  FIVE_BEDROOM_APARTMENT: {
    label: 'Căn Hộ 5 Phòng Ngủ',
    group: 'STUDIO',
    value: 'FIVE_BEDROOM_APARTMENT',
  },
  ONE_BEDROOM_VILLA: {
    label: 'Biệt Thự 1 Phòng Ngủ',
    group: 'STUDIO',
    value: 'FIVE_BEDROOM_APARTMENT',
  },
  TWO_BEDROOM_VILLA: {
    label: 'Biệt Thự 2 Phòng Ngủ',
    group: 'STUDIO',
    value: 'TWO_BEDROOM_VILLA',
  },
  THREE_BEDROOM_VILLA: {
    label: 'Biệt Thự 3 Phòng Ngủ',
    group: 'STUDIO',
    value: 'THREE_BEDROOM_VILLA',
  },
  FOUR_BEDROOM_VILLA: {
    label: 'Biệt Thự 4 Phòng Ngủ',
    group: 'STUDIO',
    value: 'FOUR_BEDROOM_VILLA',
  },
  FIVE_BEDROOM_VILLA: {
    label: 'Biệt Thự 5 Phòng Ngủ',
    value: 'FIVE_BEDROOM_VILLA',
    group: 'STUDIO',
  },
};

export const LANDMARK_LIST = [
  {
    value: 'BACK_BEACH',
    label: 'Bãi Sau',
    group: 'VUNG_TAU',
  },
  {
    value: 'FRONT_BEACH',
    label: 'Bãi Trước',
    group: 'VUNG_TAU',
  },
  {
    value: 'PINEAPPLE_BEACH',
    label: 'Bãi Dứa',
    group: 'VUNG_TAU',
  },
  {
    value: 'MULBERRY_BEACH',
    label: 'Bãi Dâu',
    group: 'VUNG_TAU',
  },
  {
    value: 'LONG_CUNG_BEACH',
    label: 'Bãi Biển Long Cung',
    group: 'VUNG_TAU',
  },
  {
    value: 'VUNG_TAU_CITY_BEACH',
    label: 'Trung Tâm Thành Phố Vũng Tàu',
    group: 'VUNG_TAU',
  },
  {
    value: 'XUAN_HUONG_LAKE',
    label: 'Hồ Xuân Hương',
    group: 'DA_LAT',
  },
  {
    value: 'TUYEN_LAM_LAKE',
    group: 'DA_LAT',
    label: 'Hồ Tuyền Lâm',
  },
  {
    value: 'DA_LAT_MARKET',
    group: 'DA_LAT',
    label: 'Chợ Đà Lạt',
  },
  {
    value: 'CENTRAL_MUI_NE_BEACH',
    group: 'MUI_NE',
    label: 'Bãi Biển Trung Tâm Mũi Né',
  },
  {
    value: 'RED_SAND_DUNES',
    group: 'MUI_NE',
    label: 'Đồi Cát Đỏ',
  },
  {
    value: 'PHU_HAI_BEACH',
    group: 'MUI_NE',
    label: 'Bãi Biển Phú Hải',
  },
  {
    value: 'CON_SON_BEACH',
    group: 'CON_DAO',
    label: 'Bãi Biên Côn Sơn',
  },
  {
    value: 'LO_VOI_BEACH',
    group: 'CON_DAO',
    label: 'Bãi Biển Lò Vôi',
  },
  {
    value: 'SUOI_OT_BEACH',
    group: 'CON_DAO',
    label: 'Bãi Biên Suối Ớt',
  },
  {
    value: 'CON_DAO_HABOUR',
    group: 'CON_DAO',
    label: 'Bến Tàu Côn Đảo',
  },
  {
    value: 'AN_HAI_BEACH',
    group: 'CON_DAO',
    label: 'Bãi Biển An Hải',
  },
  {
    value: 'DAT_DOC_BEACH',
    group: 'CON_DAO',
    label: 'Bãi Biển Đất Dốc',
  },
  {
    value: 'CON_DAO_MARKET',
    group: 'CON_DAO',
    label: 'Chợ Côn Đảo',
  },
  {
    value: 'LONG_BEACH',
    group: 'CAM_RANH',
    label: 'Bãi Dài',
  },
  {
    value: 'BINH_BA_ISLAND',
    group: 'CAM_RANH',
    label: 'Đảo Bình Ba',
  },
  {
    value: 'CAM_RANH_BAY',
    group: 'CAM_RANH',
    label: 'Vịnh Cam Ranh',
  },
  {
    value: 'QUY_NHON_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Quy Nhơn',
  },
  {
    value: 'QUEEN_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Hoàng Hậu',
  },
  {
    value: 'KY_CO_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Kỳ Co',
  },
  {
    value: 'QUY_HOA_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Quy Hòa',
  },
  {
    value: 'DUONG_DONG',
    group: 'PHU_QUOC',
    label: 'Dương Đông',
  },
  {
    value: 'AN_THOI',
    group: 'PHU_QUOC',
    label: 'An Thới',
  },
  {
    value: 'CUA_CAN',
    group: 'PHU_QUOC',
    label: 'Cửa Cạn',
  },
  {
    value: 'DUONG_TO',
    group: 'PHU_QUOC',
    label: 'Dương Tơ',
  },
  {
    value: 'THOM_BEACH',
    group: 'PHU_QUOC',
    label: 'Bãi Thơm',
  },
  {
    value: 'HAM_NINH',
    group: 'PHU_QUOC',
    label: 'Hàm Ninh',
  },
  {
    value: 'GANH_DAU',
    group: 'PHU_QUOC',
    label: 'Gành Dầu',
  },
  {
    value: 'ONG_LANG',
    group: 'PHU_QUOC',
    label: 'Ông Lang',
  },
  {
    value: 'QUY_NHON_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Quy Nhơn',
  },
  {
    value: 'QUEEN_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Hoàng Hậu',
  },
  {
    value: 'KY_CO_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Kỳ Co',
  },
  {
    value: 'QUY_HOA_BEACH',
    group: 'QUY_NHON',
    label: 'Bãi Biển Quy Hòa',
  },
  {
    value: 'DUONG_DONG',
    group: 'PHU_QUOC',
    label: 'Dương Đông',
  },
  {
    value: 'AN_THOI',
    group: 'PHU_QUOC',
    label: 'An Thới',
  },
  {
    value: 'CUA_CAN',
    group: 'PHU_QUOC',
    label: 'Cửa Cạn',
  },
  {
    value: 'DUONG_TO',
    group: 'PHU_QUOC',
    label: 'Dương Tơ',
  },
  {
    value: 'THOM_BEACH',
    group: 'PHU_QUOC',
    label: 'Bãi Thơm',
  },
  {
    value: 'HAM_NINH',
    group: 'PHU_QUOC',
    label: 'Hàm Ninh',
  },
  {
    value: 'GANH_DAU',
    group: 'PHU_QUOC',
    label: 'Gành Dầu',
  },
  {
    value: 'ONG_LANG',
    group: 'PHU_QUOC',
    label: 'Ông Lang',
  },
  {
    value: 'NINH_KIEU_WHARF',
    group: 'CAN_THO',
    label: 'Bến Ninh Kiều',
  },
  {
    value: 'CAI_RANG_FLOATING_MARKET',
    group: 'CAN_THO',
    label: 'Chợ Nổi Cái Răng',
  },
  {
    value: 'CAN_THO_CITY_CENTER',
    group: 'CAN_THO',
    label: 'Trung Tâm Thành Phố Cần Thơ',
  },
  {
    value: 'KHUONG_RIVER_ISLAND',
    group: 'CAN_THO',
    label: 'Cồn Khương',
  },
  {
    value: 'CAI_KHE_MARKET',
    group: 'CAN_THO',
    label: 'Chợ Cái Khế',
  },
  {
    value: 'SA_PA_LAKE',
    group: 'SA_PA',
    label: 'Hồ Sa Pa',
  },
  {
    value: 'SA_PA_NIGHT_MARKET',
    group: 'SA_PA',
    label: 'Chợ Đêm Sa Pa',
  },
  {
    value: 'HAM_RONG_MOUNTAIN',
    group: 'SA_PA',
    label: 'Núi Hàm Rồng',
  },
  {
    value: 'MUONG_HOA_VALLEY',
    group: 'SA_PA',
    label: 'Thung Lũng Mường Hoa',
  },
  {
    value: 'HAN_RIVER',
    group: 'DA_NANG',
    label: 'Sông Hàn',
  },
  {
    value: 'MY_KHE_BEACH',
    group: 'DA_NANG',
    label: 'Bãi Biển Mỹ Khê',
  },
  {
    value: 'MARBLE_MOUNTAIN',
    group: 'DA_NANG',
    label: 'Núi Bi',
  },
  {
    value: 'BAC_MY_AN_BEACH',
    group: 'DA_NANG',
    label: 'Bãi Biển Bắc Mỹ An',
  },
  {
    value: 'NON_NUOC_BEACH',
    group: 'DA_NANG',
    label: 'Bãi Biển Non Nước',
  },
  {
    value: 'DA_NANG_BAY',
    group: 'DA_NANG',
    label: 'Vịnh Đà Nẵng',
  },
  {
    value: 'THO_QUANG_BEACH',
    group: 'DA_NANG',
    label: 'Bãi Biển Thọ Quang',
  },
  {
    value: 'SON_TRA_PENINSULA',
    group: 'DA_NANG',
    label: 'Bán Đảo Sơn Trà',
  },
  {
    value: 'DA_NANG_CITY_CENTER',
    group: 'DA_NANG',
    label: 'Trung Tâm Thành Phố Đà Nẵng',
  },
  {
    value: 'ANCIENT_TOWN',
    group: 'HOI_AN',
    label: 'Phố Cổ',
  },
  {
    value: 'AN_BANG_BEACH',
    group: 'HOI_AN',
    label: 'Bãi Biển An Bàng',
  },
  {
    value: 'CUA_DAI_BEACH',
    group: 'HOI_AN',
    label: 'Bãi Biển Cửa Đại',
  },
  {
    value: 'IMPERIAL_CITY',
    group: 'HUE',
    label: 'Hoàng Thành',
  },
  {
    value: 'THIEN_MU_PAGODA',
    group: 'HUE',
    label: 'Chùa Thiên Mụ',
  },
  {
    value: 'LANG_CO_BEACH',
    group: 'HUE',
    label: 'Bãi Biển Lăng Cô',
  },
  {
    value: 'THUAN_AN_BEACH',
    group: 'HUE',
    label: 'Bãi Biển Thuận An',
  },
  {
    value: 'HUE_CITY_CENTER',
    group: 'HUE',
    label: 'Trung Tâm Thành Phố Huế',
  },
];

export const STATUS_LIST = [
  { value: 'READY', label: 'Sẵn sàng' },
  { value: 'CONTACTING', label: 'Liên hệ' },
  { value: 'ASSIGNED', label: 'Ký hợp đồng' },
  { value: 'CHANGED_OWNER', label: 'Đổi chủ' },
];

export const GROUP_ROOM_TYPE = [
  {
    label: 'Phòng Standard',
    options: [
      ROOM_TYPE.STANDARD_SINGLE_ROOM,
      ROOM_TYPE.STANDARD_DOUBLE_ROOM,
      ROOM_TYPE.STANDARD_TWIN_ROOM,
      ROOM_TYPE.STANDARD_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.STANDARD_QUEEN_ROOM,
      ROOM_TYPE.STANDARD_KING_ROOM,
      ROOM_TYPE.STANDARD_TRIPLE_ROOM,
      ROOM_TYPE.STANDARD_QUADRUPLE_ROOM,
      ROOM_TYPE.STANDARD_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Superior',
    options: [
      ROOM_TYPE.SUPERIOR_SINGLE_ROOM,
      ROOM_TYPE.SUPERIOR_DOUBLE_ROOM,
      ROOM_TYPE.SUPERIOR_TWIN_ROOM,
      ROOM_TYPE.SUPERIOR_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.SUPERIOR_QUEEN_ROOM,
      ROOM_TYPE.SUPERIOR_KING_ROOM,
      ROOM_TYPE.SUPERIOR_TRIPLE_ROOM,
      ROOM_TYPE.SUPERIOR_QUADRUPLE_ROOM,
      ROOM_TYPE.SUPERIOR_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Deluxe',
    options: [
      ROOM_TYPE.DELUXE_SINGLE_ROOM,
      ROOM_TYPE.DELUXE_DOUBLE_ROOM,
      ROOM_TYPE.DELUXE_TWIN_ROOM,
      ROOM_TYPE.DELUXE_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.DELUXE_QUEEN_ROOM,
      ROOM_TYPE.DELUXE_KING_ROOM,
      ROOM_TYPE.DELUXE_TRIPLE_ROOM,
      ROOM_TYPE.DELUXE_QUADRUPLE_ROOM,
      ROOM_TYPE.DELUXE_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Premier',
    options: [
      ROOM_TYPE.PREMIER_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.PREMIER_DOUBLE_ROOM,
      ROOM_TYPE.PREMIER_TWIN_ROOM,
      ROOM_TYPE.PREMIER_QUEEN_ROOM,
      ROOM_TYPE.PREMIER_KING_ROOM,
      ROOM_TYPE.PREMIER_TRIPLE_ROOM,
      ROOM_TYPE.PREMIER_QUADRUPLE_ROOM,
      ROOM_TYPE.PREMIER_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Premium',
    options: [
      ROOM_TYPE.PREMIUM_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.PREMIUM_DOUBLE_ROOM,
      ROOM_TYPE.PREMIUM_TWIN_ROOM,
      ROOM_TYPE.PREMIUM_QUEEN_ROOM,
      ROOM_TYPE.PREMIUM_KING_ROOM,
      ROOM_TYPE.PREMIUM_TRIPLE_ROOM,
      ROOM_TYPE.PREMIUM_QUADRUPLE_ROOM,
      ROOM_TYPE.PREMIUM_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Premier Deluxe',
    options: [
      ROOM_TYPE.PREMIER_DELUXE_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_DOUBLE_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_TWIN_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_QUEEN_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_KING_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_TRIPLE_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_QUADRUPLE_ROOM,
      ROOM_TYPE.PREMIER_DELUXE_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Premium Deluxe',
    options: [
      ROOM_TYPE.PREMIUM_DELUXE_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_DOUBLE_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_TWIN_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_QUEEN_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_KING_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_TRIPLE_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_QUADRUPLE_ROOM,
      ROOM_TYPE.PREMIUM_DELUXE_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Executive Double',
    options: [
      ROOM_TYPE.EXECUTIVE_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.EXECUTIVE_DOUBLE_ROOM,
      ROOM_TYPE.EXECUTIVE_TWIN_ROOM,
      ROOM_TYPE.EXECUTIVE_QUEEN_ROOM,
      ROOM_TYPE.EXECUTIVE_KING_ROOM,
      ROOM_TYPE.EXECUTIVE_TRIPLE_ROOM,
      ROOM_TYPE.EXECUTIVE_QUADRUPLE_ROOM,
      ROOM_TYPE.EXECUTIVE_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Executive Deluxe',
    options: [
      ROOM_TYPE.EXECUTIVE_DELUXE_DOUBLE_OR_TWIN_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_DOUBLE_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_TWIN_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_QUEEN_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_KING_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_TRIPLE_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_QUADRUPLE_ROOM,
      ROOM_TYPE.EXECUTIVE_DELUXE_FAMILY_ROOM,
    ],
  },
  {
    label: 'Phòng Bungalow Standard',
    options: [
      ROOM_TYPE.STANDARD_SINGLE_BUNGALOW,
      ROOM_TYPE.STANDARD_DOUBLE_OR_TWIN_BUNGALOW,
      ROOM_TYPE.STANDARD_DOUBLE_BUNGALOW,
      ROOM_TYPE.STANDARD_TWIN_BUNGALOW,
      ROOM_TYPE.STANDARD_QUEEN_BUNGALOW,
      ROOM_TYPE.STANDARD_KING_BUNGALOW,
      ROOM_TYPE.STANDARD_TRIPLE_BUNGALOW,
      ROOM_TYPE.STANDARD_QUADRUPLE_BUNGALOW,
      ROOM_TYPE.STANDARD_FAMILY_BUNGALOW,
    ],
  },
  {
    label: 'Phòng Bungalow Superior',
    options: [
      ROOM_TYPE.SUPERIOR_SINGLE_BUNGALOW,
      ROOM_TYPE.SUPERIOR_DOUBLE_OR_TWIN_BUNGALOW,
      ROOM_TYPE.SUPERIOR_DOUBLE_BUNGALOW,
      ROOM_TYPE.SUPERIOR_TWIN_BUNGALOW,
      ROOM_TYPE.SUPERIOR_QUEEN_BUNGALOW,
      ROOM_TYPE.SUPERIOR_KING_BUNGALOW,
      ROOM_TYPE.SUPERIOR_TRIPLE_BUNGALOW,
      ROOM_TYPE.SUPERIOR_QUADRUPLE_BUNGALOW,
      ROOM_TYPE.SUPERIOR_FAMILY_BUNGALOW,
    ],
  },
  {
    label: 'Phòng Bungalow Deluxe',
    options: [
      ROOM_TYPE.DELUXE_SINGLE_BUNGALOW,
      ROOM_TYPE.DELUXE_DOUBLE_OR_TWIN_BUNGALOW,
      ROOM_TYPE.DELUXE_DOUBLE_BUNGALOW,
      ROOM_TYPE.DELUXE_TWIN_BUNGALOW,
      ROOM_TYPE.DELUXE_QUEEN_BUNGALOW,
      ROOM_TYPE.DELUXE_KING_BUNGALOW,
      ROOM_TYPE.DELUXE_TRIPLE_BUNGALOW,
      ROOM_TYPE.DELUXE_QUADRUPLE_BUNGALOW,
      ROOM_TYPE.DELUXE_FAMILY_BUNGALOW,
    ],
  },
  {
    label: 'Studio',
    options: [
      ROOM_TYPE.ONE_BEDROOM_APARTMENT,
      ROOM_TYPE.TWO_BEDROOM_APARTMENT,
      ROOM_TYPE.THREE_BEDROOM_APARTMENT,
      ROOM_TYPE.FOUR_BEDROOM_APARTMENT,
      ROOM_TYPE.FIVE_BEDROOM_APARTMENT,
      ROOM_TYPE.ONE_BEDROOM_VILLA,
      ROOM_TYPE.TWO_BEDROOM_VILLA,
      ROOM_TYPE.THREE_BEDROOM_VILLA,
      ROOM_TYPE.FOUR_BEDROOM_VILLA,
      ROOM_TYPE.FIVE_BEDROOM_VILLA,
    ],
  },
];

export const OPTION_AGES = {
  ABOVE: {
    value: 'ABOVE',
    label: 'Trên',
  },
  BELOW: {
    value: 'BELOW',
    label: 'Dưới',
  },
  FROM: {
    value: 'FROM',
    label: 'Từ',
  },
};

export const OPTION_AGES_EXTRA_BED = {
  ANY: {
    value: 'ANY',
    label: 'Bất kỳ',
  },
  FROM: {
    value: 'FROM',
    label: 'Từ',
  },
};

export const PAYMENT_TYPE = {
  INTERNATIONAL: {
    key: 'INTERNATIONAL',
    label: 'Mastercard/ Visa',
  },
  DOMESTIC: {
    key: 'DOMESTIC',
    label: 'Napas',
  },
  QR: {
    key: 'QR',
    label: 'Momo',
  },
  CASH: {
    key: 'CASH',
    label: 'Tiền mặt',
  },
};

export {
  CUSTOMER_ACCOUNT_TYPE,
  CUSTOMER_ACCOUNT_TYPE_LABELS,
  CUSTOMER_ACCOUNT_TYPE_OPTIONS,
  CUSTOMER_LABEL_TO_ACCOUNT_TYPE,
} from './customerAccountType';

export const CURRENCY_LABEL = '₫';

export const COMPLAINT_STATUS = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  SKIPPED: 'SKIPPED',
};

export const COMPLAINT_STATUS_LIST = [
  { value: COMPLAINT_STATUS.PENDING, label: 'Đang chờ xử lý', color: 'caution' },
  { value: COMPLAINT_STATUS.RESOLVED, label: 'Đã xử lý', color: 'success' },
  { value: COMPLAINT_STATUS.SKIPPED, label: 'Từ chối', color: 'error' },
];

export const COMPLAINT_TYPE = {
  BOOKING: 'BOOKING',
  DELAYED_OR_WRONG_DELIVERY: 'DELAYED_OR_WRONG_DELIVERY',
  SERVICE_ATTITUDE: 'SERVICE_ATTITUDE',
  SUGGESTION: 'SUGGESTION',
  OTHER_SERVICE_FEEDBACK: 'OTHER_SERVICE_FEEDBACK',
};

export const COMPLAINT_TYPE_LIST = [
  { value: COMPLAINT_TYPE.BOOKING, label: 'Đơn đặt phòng' },
  { value: COMPLAINT_TYPE.DELAYED_OR_WRONG_DELIVERY, label: 'Giao hàng' },
  { value: COMPLAINT_TYPE.SERVICE_ATTITUDE, label: 'Thái độ' },
  { value: COMPLAINT_TYPE.SUGGESTION, label: 'Kiến nghị' },
  { value: COMPLAINT_TYPE.OTHER_SERVICE_FEEDBACK, label: 'Khác' },
];

// For backward compatibility alias
export const COMPLAINT_CATEGORY = COMPLAINT_TYPE;
export const COMPLAINT_CATEGORY_LIST = COMPLAINT_TYPE_LIST;

export const TCXH_FEEDBACK_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  RESOLVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const TCXH_FEEDBACK_STATUS_LIST = [
  { value: TCXH_FEEDBACK_STATUS.PENDING, label: 'Chờ xử lý', color: 'caution' },
  { value: TCXH_FEEDBACK_STATUS.APPROVED, label: 'Đã xử lý', color: 'success' },
  { value: TCXH_FEEDBACK_STATUS.REJECTED, label: 'Từ chối', color: 'error' },
];
